import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { baseUrl } from "../../context/BaseUrl";

const Notify = ({ handle }) => {
  // For Suggestion form
  const [notifications, setNotifications] = useState([
    {
      id: "ob12",
      title: "institute added",
      time: "5 min ago",
    },
    {
      id: "ob13",
      title: "course added",
      time: "10 min ago",
    },
    {
      id: "ob14",
      title: "exam added",
      time: "12 min ago",
    },
    {
      id: "ob15",
      title: "job posted",
      time: "20 min ago",
    },
  ]);

  const { showNotification, setShowNotification } = handle;

  return (
    <React.Fragment>
      <Modal
        show={showNotification}
        onHide={() => setShowNotification(!showNotification)}
        className="suggestion-box"
      >
        <Modal.Header closeButton>
          <Modal.Title>Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {notifications.map((item) => (
              <div className="col-12 shadow mb-3 p-2" key={item.id}>
                <p className="fw-bold mb-1 text-capitalize">{item.title}</p>
                <small>{item.time}</small>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Notify;
